module.exports = __webpack_public_path__ + "img/icon-close-black.ba933fa7.svg";